import { ReactNode } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { alpha } from '@mui/material/styles';
import LaunchRoundedIcon from '@mui/icons-material/LaunchRounded';
import MenuBookRoundedIcon from '@mui/icons-material/MenuBookRounded';
import PublicRoundedIcon from '@mui/icons-material/PublicRounded';
import { HomeCard } from './HomeCard';

// Curated external destinations. Edit this list to match the portal's
// most-used links (same role as the previous HomePageToolkit).
type QuickLink = {
  label: string;
  href: string;
  icon: ReactNode;
};

const LINKS: QuickLink[] = [
  {
    label: 'TotalEnergies AI Catalog',
    href: 'https://totalenergiescode.github.io/ai-catalog',
    icon: <PublicRoundedIcon sx={{ fontSize: 17 }} />,
  },
  {
    label: 'PANDA deployment guide',
    href: '/docs',
    icon: <MenuBookRoundedIcon sx={{ fontSize: 17 }} />,
  },
];

export const QuickLinksCard = () => (
  <HomeCard title="Quick links">
    {LINKS.map(link => (
      <Box
        key={link.label}
        component="a"
        href={link.href}
        target={link.href.startsWith('http') ? '_blank' : undefined}
        rel={link.href.startsWith('http') ? 'noopener' : undefined}
        sx={theme => ({
          display: 'flex',
          alignItems: 'center',
          gap: 1.25,
          px: 1,
          py: 1.1,
          mx: -1,
          borderRadius: '8px',
          textDecoration: 'none',
          color: 'text.primary',
          '&:hover': {
            bgcolor: alpha(theme.palette.primary.main, 0.09),
          },
        })}
      >
        <Box
          sx={{ color: 'text.secondary', display: 'inline-flex', flex: 'none' }}
        >
          {link.icon}
        </Box>
        <Typography sx={{ fontSize: 13.5, fontWeight: 500, flex: 1 }}>
          {link.label}
        </Typography>
        <LaunchRoundedIcon sx={{ fontSize: 13, color: 'text.secondary' }} />
      </Box>
    ))}
  </HomeCard>
);
